import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const campusImages = [
  { url: "https://upload.wikimedia.org/wikipedia/commons/2/2e/IITBMainBuildingCROP.jpg", name: "IIT Bombay" },
  { url: "https://upload.wikimedia.org/wikipedia/commons/0/0d/IIT_Delhi_Main_Building.jpeg", name: "IIT Delhi" },
  { url: "https://upload.wikimedia.org/wikipedia/commons/7/75/IIT_Kanpur.jpg", name: "IIT Kanpur" },
  { url: "https://upload.wikimedia.org/wikipedia/commons/8/84/Indian_Institute_of_Management_Bangalore%2C_Entrance.jpg", name: "IIM Bangalore" },
  { url: "https://upload.wikimedia.org/wikipedia/commons/3/34/BITS_Clocktower.jpg", name: "BITS Pilani" },
  { url: "https://upload.wikimedia.org/wikipedia/commons/3/39/Maitreyi_College_building%2C_Delhi.jpg", name: "Delhi University" }
];

const slideVariants = {
  enter: {
    x: "100%",
  },
  center: {
    x: 0,
  },
  exit: {
    x: "-100%",
  },
};

const CampusCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % campusImages.length);
    }, 5000); // 5 seconds per image
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative aspect-[4/3] lg:aspect-auto lg:h-[400px] overflow-hidden rounded-3xl shadow-2xl bg-black">
      <AnimatePresence initial={false} mode="popLayout">
        <motion.div
          key={currentIndex}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="absolute inset-0"
        >
          <img 
            src={campusImages[currentIndex].url}
            alt={campusImages[currentIndex].name}
            className="w-full h-full object-cover grayscale"
          />
          {/* Gradient overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          
          {/* College name in bottom left */}
          <div className="absolute bottom-4 left-4">
            <span className="text-white/90 text-sm font-medium tracking-wide">
              {campusImages[currentIndex].name}
            </span>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default CampusCarousel;
